import { SELECTED_ITEM_ALL_ID } from '../../../user/population-select';
import {
    DataDimension,
    DataSource,
    Parameters,
    ReportType,
} from '../../backend';
import { currentBuilderState } from '../builder.state';

export function createParams(): Parameters {
    const state = currentBuilderState();
    const vp = state.viewParams;
    const bp: Parameters = {
        dataSource: null,
        periodType: null,
        startDate: null,
        endDate: null,
        reportType: null,
        roles: null,
        teams: null,
        individuals: null,
        dataDimension: null,
        sites: null,
        queues: null,
        superGroups: null,
        metrics: null,
    };

    switch (vp.dataSource) {
        case DataSource.Cache:
            bp.dataSource = DataSource.Cache;

            bp.periodType = { id: vp.periodType?.id };
            bp.startDate = vp.cacheDate?.startDate;
            bp.endDate = vp.cacheDate?.endDate;

            break;
        case DataSource.Raw:
            bp.dataSource = DataSource.Raw;

            bp.periodType = { id: vp.periodType?.id };
            bp.startDate = vp.rawStartDate;
            bp.endDate = vp.rawEndDate;

            break;
    }

    switch (vp.reportType) {
        case ReportType.Role:
            bp.reportType = ReportType.Role;

            bp.roles = [{ id: vp.role?.[0]?.id }];
            bp.sites = [
                {
                    id:
                        vp.site?.[0]?.id === SELECTED_ITEM_ALL_ID
                            ? -1
                            : vp.site?.[0]?.id,
                },
            ];

            switch (vp.dataDimension) {
                case DataDimension.SuperGroup:
                    bp.dataDimension = DataDimension.SuperGroup;
                    bp.superGroups = [{ id: vp.superGroup?.[0]?.id }];
                    break;
                case DataDimension.Queue:
                    bp.dataDimension = DataDimension.Queue;
                    bp.queues = [
                        {
                            id:
                                vp.queue?.[0]?.id === SELECTED_ITEM_ALL_ID
                                    ? -1
                                    : vp.queue?.[0]?.id,
                        },
                    ];
                    break;
            }
            break;
        case ReportType.Team:
            bp.reportType = ReportType.Team;

            bp.teams = [{ id: vp.team?.[0]?.id }];
            bp.queues = [
                {
                    id:
                        vp.queue?.[0]?.id === SELECTED_ITEM_ALL_ID
                            ? -1
                            : vp.queue?.[0]?.id,
                },
            ];
            break;
        case ReportType.Individual:
            bp.reportType = vp.reportType;

            bp.individuals = [{ id: vp.individual?.[0]?.id }];
            bp.queues = [
                {
                    id:
                        vp.queue?.[0]?.id === SELECTED_ITEM_ALL_ID
                            ? -1
                            : vp.queue?.[0]?.id,
                },
            ];
            break;
    }

    bp.metrics = vp.metrics?.map((e) => {
        return { id: e.id };
    });

    return bp;
}
